import React, { useState } from "react";

interface QAItem {
  question: string;
  answer: string;
}

interface ToggleDivsProps {
  questions: QAItem[];
}

const ToggleFaq: React.FC<ToggleDivsProps> = ({ questions }) => {
  // State to track which div is currently expanded (null means none are expanded)
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);

  const handleToggle = (index: number) => {
    // If the same div is clicked, collapse it, otherwise expand it
    setExpandedIndex(expandedIndex === index ? null : index);
  };

  return (
    <div>
      {questions.map((que, index) => (
        <div
          className="py-4 px-5 md:py-7 md:px-9 border border-[#FC7A69] rounded-2xl mb-3"
          key={index}
        >
          <button
            className="flex justify-between items-center w-full focus:outline-none"
            onClick={() => handleToggle(index)}
          >
            <span className="text-sm md:text-2xl font-medium pr-5 text-[#FC7A69] text-left">
              {que.question}
            </span>

            <span className="text-2xl md:text-[40px] leading-none font-normal text-white pl-4">
              {expandedIndex === index ? "-" : "+"}
            </span>
          </button>

          {/* Only show the content of the div if it's expanded */}
          {expandedIndex === index && (
            <div className="content text-left">
              {que.answer.split("<br />").map((line, idx) => (
                <p
                  className="text-xs md:text-2xl font-medium pr-5 text-white"
                  key={idx}
                  dangerouslySetInnerHTML={{ __html: line }}
                ></p>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ToggleFaq;
